import React, { useMemo } from 'react';
import { hasAccess } from 'cp-client-auth!sofe';
import { BaseNav } from './base-nav.component';
import { useNav } from '../../nav.context';

export const BillingNav = () => {
  const nav = useNav();
  const navLinks = useMemo(() => {
    const hasPayments = hasAccess(nav.user)(['billing_payments']);
    const allowInvoices = hasAccess(nav.user)('billing_invoices');
    const allowCredits = hasAccess(nav.user)('billing_credits');
    const allowStatements = hasAccess(nav.user)('billing_statements');
    const allowDashboard = hasAccess(nav.user)('billing_dashboard');
    const allowReports = hasAccess(nav.user)('billing_reports');

    return [
      { label: 'Dashboard', url: 'billing/dashboard', enabled: allowDashboard },
      { label: 'Invoices', url: 'billing/invoices', enabled: allowInvoices },
      { label: 'Payments', url: 'billing/payments/collected', enabled: hasPayments },
      { label: 'Credits', url: 'billing/credits', enabled: allowCredits },
      { label: 'Statements', url: 'billing/statements', enabled: allowStatements },
      { label: 'Reports', url: 'billing/reports', enabled: allowReports },
    ];
  }, [nav.user]);

  return <BaseNav title="Billing" nav={nav} navLinks={navLinks} />;
};
